import http from '../const/http-common'

const getSources = (sourceInfo) => {
  return http.post('/v1/source/get-list', sourceInfo);
}

const getSource = (sourceInfo) => {
  return http.post('/v1/source/get', sourceInfo);
}

const createSource = (sourceInfo) => {
  return http.post('/v1/source/create', sourceInfo);
}

const updateSource = (sourceId, sourceInfo) => {
  return http.put(`/v1/source/${sourceId}/update`, sourceInfo);
}

const deleteSource = (id) => {
  return http.delete(`/v1/source/${id}/delete`);
}

const checkSourceAuth = (sourceInfo) => {
  return http.post('/v1/source/check-auth', sourceInfo);
}

const saveUserCredentials = (credentialInfo) => {
  return http.post('/v1/source/save-user-credentials', credentialInfo);
}

const deactivateUserCredentials = (sourceId) => {
  return http.post('/v1/source/deactivate-user-credentials', { source_id: sourceId });
}

const getSourceWithCredentials = (sourceName) => {
  return http.post('/v1/source/get-source-with-credentials', { source_name: sourceName });
}

const testOracleEpmConnection = (connectionInfo) => {
  return http.post('/v1/source/test-connection', connectionInfo);
}

const syncOracleEpmMetadata = (syncInfo) => {
  return http.post('/v1/source/sync-oracle-epm-metadata', syncInfo);
}

const createOracleEpmConfig = (configInfo) => {
  return http.post('/v1/source/oracle-epm-config/create', configInfo);
}

const getOracleEpmConfigBySource = (sourceId) => {
  const formData = new FormData();
  formData.append('source_id', sourceId);
  return http.post('/v1/source/oracle-epm-config/get-by-source', formData);
}

const getCubesBySource = (sourceId, page = 1, pageSize = 10) => {
  return http.get(`/v1/cube/source/${sourceId}`, {
    params: { page, page_size: pageSize }
  });
}

const userService = {
  getSources,
  getSource,
  createSource,
  updateSource,
  deleteSource,
  checkSourceAuth,
  saveUserCredentials,
  deactivateUserCredentials,
  getSourceWithCredentials,
  testOracleEpmConnection,
  syncOracleEpmMetadata,
  createOracleEpmConfig,
  getOracleEpmConfigBySource,
  getCubesBySource
}

export default userService